import React, { Component, Fragment } from "react";
import Breadcrumb from "../common/breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getCurrency, updateCurrency } from "../../firebase/firebase.utils";

const FIELDS = [
  {
    key: "taka",
    label: "1 RMB (Yuan) =",
    unit: "Taka",
    placeholder: "e.g. 15",
    hint: "Exchange rate: how many Bangladeshi Taka equals 1 Chinese Yuan",
  },
  {
    key: "shippingFee",
    label: "Shipping Fee",
    unit: "Taka / kg",
    placeholder: "e.g. 1200",
    hint: "Shipping charge per kg from China to Bangladesh",
  },
];

export class Currency extends Component {
  constructor(props) {
    super(props);
    this.state = {
      taka: "",
      shippingFee: "",
      saving: false,
      loaded: false,
    };
  }

  componentDidMount = async () => {
    const data = await getCurrency();
    if (data) {
      this.setState({
        taka: data.taka != null ? String(data.taka) : "",
        shippingFee: data.shippingFee != null ? String(data.shippingFee) : "",
        loaded: true,
      });
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { taka, shippingFee } = this.state;
    if (!taka || !shippingFee) {
      toast.error("Both fields are required.");
      return;
    }
    this.setState({ saving: true });
    await updateCurrency({ taka: String(taka), shippingFee: String(shippingFee) });
    this.setState({ saving: false });
    toast.success("Currency settings updated!");
  };

  render() {
    const { taka, shippingFee, saving, loaded } = this.state;
    const values = { taka, shippingFee };

    return (
      <Fragment>
        <Breadcrumb title="Currency Converter" parent="Localization" />
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-8">
              <div
                className="card"
                style={{ boxShadow: "0 1px 4px rgba(0,0,0,0.08)", border: "1px solid #F0F0F0" }}
              >
                <div
                  className="card-header"
                  style={{ padding: "20px 24px", borderBottom: "1px solid #F3F3F3", background: "white" }}
                >
                  <div style={{ fontWeight: 700, fontSize: 16, color: "#1A1A2E" }}>
                    Currency Converter
                  </div>
                  <div style={{ fontSize: 13, color: "#888", marginTop: 3 }}>
                    Update exchange rate and shipping fee
                  </div>
                </div>
                <div className="card-body" style={{ padding: 24 }}>
                  {!loaded ? (
                    <div style={{ textAlign: "center", padding: 40, color: "#AAA" }}>Loading...</div>
                  ) : (
                    <form onSubmit={this.handleSubmit}>
                      {FIELDS.map((field) => (
                        <div key={field.key} style={{ marginBottom: 24 }}>
                          <label
                            style={{
                              display: "block",
                              fontSize: 13,
                              fontWeight: 600,
                              color: "#374151",
                              marginBottom: 6,
                            }}
                          >
                            {field.label}
                          </label>
                          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <input
                              type="number"
                              name={field.key}
                              value={values[field.key]}
                              onChange={this.handleChange}
                              placeholder={field.placeholder}
                              required
                              min="0"
                              style={{
                                flex: 1,
                                padding: "10px 14px",
                                border: "1.5px solid #E5E7EB",
                                borderRadius: 8,
                                fontSize: 15,
                                fontWeight: 600,
                                color: "#1A1A2E",
                                outline: "none",
                              }}
                            />
                            <span
                              style={{
                                background: "#F3F0FF",
                                color: "#6C63FF",
                                borderRadius: 6,
                                padding: "8px 14px",
                                fontSize: 13,
                                fontWeight: 600,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {field.unit}
                            </span>
                          </div>
                          <div style={{ fontSize: 12, color: "#9CA3AF", marginTop: 4 }}>
                            {field.hint}
                          </div>
                        </div>
                      ))}

                      <button
                        type="submit"
                        disabled={saving}
                        style={{
                          width: "100%",
                          padding: "12px",
                          background: saving ? "#A5B4FC" : "#6C63FF",
                          color: "white",
                          border: "none",
                          borderRadius: 8,
                          fontSize: 14,
                          fontWeight: 700,
                          cursor: saving ? "not-allowed" : "pointer",
                          marginTop: 4,
                        }}
                      >
                        {saving ? "Saving..." : "Save Changes"}
                      </button>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default Currency;
